var map = {
	"./auto_generated_day_data_da.avro": [
		148481,
		481
	],
	"./auto_generated_day_data_en-GB.avro": [
		221225,
		225
	],
	"./auto_generated_day_data_en-US.avro": [
		245044,
		44
	],
	"./auto_generated_day_data_es.avro": [
		469486,
		486
	],
	"./auto_generated_day_data_fr.avro": [
		820770,
		770
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46157;
module.exports = webpackAsyncContext;